import axios from "axios";
import { appConstants } from "./appConstants";
import { getFileType } from "./generic";

let pendingDocumentID = 0;

export const createPendingAttachment = (file) => ({
  _id: `pending-attachment-${++pendingDocumentID}`,
  documentName: file.name.replace(/\.[^.]+$/, "") || file.name,
  fileType: getFileType(file.type) || file.name.split(".").pop().toLowerCase(),
  file,
});

export const uploadPendingAttachments = async (
  type,
  documentID,
  documents,
  onUploaded
) => {
  const pending = documents.filter((document) => document.file);
  if (!pending.length) return;
  if (!documentID)
    throw new Error("Save the draft before uploading attachments.");

  for (const document of pending) {
    const formData = new FormData();
    formData.append("file", document.file);
    formData.append(`${type}ID`, documentID);
    formData.append("documentName", document.documentName);
    formData.append("fileType", document.fileType);
    if (document.documentID) formData.append("documentID", document.documentID);

    const action =
      type === "quotation"
        ? "uploadQuotationDocument"
        : type === "rcti"
        ? "uploadRCTIDocument"
        : "uploadInvoiceDocument";
    const route = type === "rcti" ? "invoice" : type;
    const { data } = await axios.post(
      `${appConstants.baseURL}${route}/${action}`,
      formData,
      {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
      }
    );
    if (!data?.Result_Status)
      throw new Error(data?.Result_Message || "Attachment upload failed.");
    onUploaded(data.Result_Output || [], document._id);
  }
};
